import React from 'react';
import { Search } from 'lucide-react';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  leftIcon?: React.ReactNode;
  fieldSize?: 'md' | 'lg';
}

export const fieldStyles = `
  w-full bg-surface border border-line-strong rounded-lg text-sm text-fg placeholder:text-muted
  transition-colors duration-150
  focus:outline-none focus:border-accent focus-visible:ring-2 focus-visible:ring-accent/25 focus-visible:ring-offset-0
  disabled:opacity-50 disabled:cursor-not-allowed
`;

export const Input: React.FC<InputProps> = ({
  label,
  error,
  leftIcon,
  fieldSize = 'md',
  className = '',
  ...props
}) => {
  const sizeStyles = fieldSize === 'lg' ? 'h-12 px-4 text-[15px]' : 'h-10 px-3';

  return (
    <div className="w-full">
      {label && (
        <label className="block text-sm font-medium text-fg mb-1.5">
          {label}
        </label>
      )}
      <div className="relative">
        {leftIcon && (
          <div className={`absolute inset-y-0 left-0 ${fieldSize === 'lg' ? 'pl-4' : 'pl-3'} flex items-center pointer-events-none text-muted`}>
            {leftIcon}
          </div>
        )}
        <input
          className={`
            ${fieldStyles} ${sizeStyles}
            ${leftIcon ? (fieldSize === 'lg' ? 'pl-11' : 'pl-10') : ''}
            ${error ? 'border-danger' : ''}
            ${className}
          `}
          {...props}
        />
      </div>
      {error && <p className="mt-1 text-sm text-danger">{error}</p>}
    </div>
  );
};

interface SearchInputProps extends Omit<InputProps, 'leftIcon'> {}

export const SearchInput: React.FC<SearchInputProps> = (props) => {
  return <Input type="search" leftIcon={<Search size={18} />} {...props} />;
};
